// Časy v místním pásmu prohlížeče. Server vypisuje <time datetime="…Z" data-fmt="…"> s UTC zálohou
// (filtr local_dt v moodix/templatetags/ui.py) a tady se text přepíše na místní čas; UTC zůstává v title.
const BASE = { hour: '2-digit', minute: '2-digit', hourCycle: 'h23' };
const OPTS = {
  time: BASE,
  wday: { ...BASE, weekday: 'short' },
  short: { ...BASE, month: 'short', day: 'numeric' },
  datetime: { ...BASE, month: 'short', day: 'numeric', year: 'numeric' },
  long: { ...BASE, weekday: 'short', month: 'short', day: 'numeric', year: 'numeric' },
};

function parts(date, fmt, zone) {
  const out = {};
  new Intl.DateTimeFormat('en-US', { ...OPTS[fmt], ...(zone ? { timeZoneName: 'short' } : {}) })
    .formatToParts(date).forEach((p) => { out[p.type] = p.value; });
  return out;
}

export function formatLocal(date, fmt = 'datetime', zone = false) {
  const p = parts(date, OPTS[fmt] ? fmt : 'datetime', zone);
  const hm = `${p.hour}:${p.minute}`;
  const text = {
    time: hm,
    wday: `${p.weekday} ${hm}`,
    short: `${p.month} ${p.day} ${hm}`,
    datetime: `${p.month} ${p.day}, ${p.year} · ${hm}`,
    long: `${p.weekday}, ${p.month} ${p.day}, ${p.year} · ${hm}`,
  }[OPTS[fmt] ? fmt : 'datetime'];
  return zone && p.timeZoneName ? `${text} ${p.timeZoneName}` : text;
}

export function localizeTimes(root = document) {
  root.querySelectorAll('time[data-fmt]:not([data-local])').forEach((el) => {
    const date = new Date(el.getAttribute('datetime'));
    if (Number.isNaN(date.getTime())) return;
    el.textContent = formatLocal(date, el.dataset.fmt, el.dataset.zone === '1');
    el.dataset.local = '1';
  });
}
